"use client";

import * as React from "react";

import { CarouselContext } from "@/components/carousel/CarouselContext";

export const useCarousel = () => {
  const context = React.useContext(CarouselContext);

  if (context === null) {
    throw new Error("useCarousel must be used within a <Carousel />");
  }

  return context;
};
